import styled, { keyframes } from 'styled-components'
import { useEffect, useContext, useState } from 'react'
import { scroller, animateScroll } from 'react-scroll'
import { LanguageContext } from '../../components/LanguageContext'
import useWindowDimensions from '../../hooks/useWindowDimension'
import Hamburger from 'hamburger-react'
import burger from '../../assets/burger.svg'

import sabFace from '../../assets/sabFace.webp'

const Header = ({ DialogTrigger, formStatus }) => {
	const { language, setLanguage } = useContext(LanguageContext)
	const [isBurgerOpen, setIsBurgerOpen] = useState(false)
	const { height, width } = useWindowDimensions()
	return (
		<div style={{ position: 'relative' }}>
			<Main>
				<Logo
					src={sabFace}
					onClick={() => {
						setIsBurgerOpen(false)
						animateScroll.scrollToTop({
							duration: 1500,
							delay: 100,
							smooth: 'easeInOutQuart',
						})
					}}
				/>
				<Spacer />
				<Container isBurgerOpen={isBurgerOpen}>
					<StyledLink
						onClick={() => {
							setIsBurgerOpen(false)
							animateScroll.scrollToTop({
								duration: 1500,
								delay: 100,
								smooth: 'easeInOutQuart',
							})
						}}
					>
						{language === 'french'
							? 'Accueil'
							: language === 'english'
							? 'Home'
							: 'Home'}
					</StyledLink>
					<StyledLink
						onClick={() => {
							setIsBurgerOpen(false)
							scroller.scrollTo('music', {
								duration: 1500,
								delay: 100,
								smooth: 'easeInOutQuart',
								offset: -65,
							})
						}}
					>
						{language === 'french'
							? 'Musique'
							: language === 'english'
							? 'Music'
							: 'Music'}
					</StyledLink>
					<StyledLink
						onClick={() => {
							setIsBurgerOpen(false)
							scroller.scrollTo('about', {
								duration: 1500,
								delay: 100,
								smooth: 'easeInOutQuart',
								offset: -65,
							})
						}}
					>
						{language === 'french'
							? 'À propos'
							: language === 'english'
							? 'About'
							: 'About'}
					</StyledLink>
					{/* <DialogTrigger asChild> */}
					<StyledLink
						onClick={() => {
							setIsBurgerOpen(false)
							scroller.scrollTo('contact', {
								duration: 1500,
								delay: 100,
								smooth: 'easeInOutQuart',
								offset: -65,
							})
						}}
					>
						Contact
					</StyledLink>
					{/* </DialogTrigger> */}
				</Container>
				<LanguageBox>
					<div>
						<LanguageTab
							onClick={() => {
								setLanguage('english')
							}}
							isSelected={language === 'english'}
						>
							EN
						</LanguageTab>{' '}
						|{' '}
						<LanguageTab
							onClick={() => {
								setLanguage('french')
							}}
							isSelected={language === 'french'}
						>
							FR
						</LanguageTab>
					</div>
				</LanguageBox>
				{width < 1000 ? (
					<Hamburger toggled={isBurgerOpen} toggle={setIsBurgerOpen} />
				) : null}
			</Main>
		</div>
	)
}

const Main = styled.header`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	height: 8vh;
	min-height: 60px;
	/* padding: 5px; */
	font-size: 1.6rem;
	width: 100vw;
	background: white;
	position: fixed;
	top: 0;
	box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
	padding-right: 25px;
	overflow: hidden;
	z-index: 5;
	line-height: 1.1;

	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
	-khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Old versions of Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
	user-select: none;
`
const Container = styled.div`
	display: flex;
	justify-content: space-evenly;
	padding: 0 20px;
	margin: 20px 0;
	min-width: 40%;
	@media (max-width: 1000px) {
		flex-direction: column;
		position: fixed;
		opacity: ${(props) => (props.isBurgerOpen ? '100%' : '0%')};
		right: ${(props) => (props.isBurgerOpen ? '0' : '-80vw')};
		top: 8vh;
		height: 92vh;
		width: 80vw;
		background: white;
		margin: 0;
		transition: 700ms;
		text-align: center;
	}
`

const Spacer = styled.div`
	flex-grow: 1;
`

const StyledLink = styled.div`
	text-decoration: none;
	color: inherit;
	transition: 10s;
	cursor: pointer;
	width: max-content;
	padding: 0 20px;
	white-space: nowrap;

	::after {
		content: '';
		width: 0px;
		height: 1px;
		display: block;
		background: black;
		transition: 300ms;
	}
	:hover::after {
		width: 100%;
	}
`
const LanguageBox = styled.div`
	cursor: pointer;
	white-space: nowrap;
	font-size: 0.8rem;
	width: fit-content;
	padding: 0 20px;
	@media (max-width: 1000px) {
		margin-right: 30px;
	}
`

const Logo = styled.img`
	height: 90%;
	padding: 5px;
	margin-left: 20px;
	width: auto;
	border-radius: 100%;
	cursor: pointer;
`

const LanguageTab = styled.span`
	text-decoration: ${(props) => (props.isSelected ? 'underline' : '')};
`

export default Header
